const RichText = ({ children }) => {
  // Pole všech podporovaných značek s jejich Tailwind CSS třídami
  const supportedTags = [
    { tag: 'strong', className: 'font-bold' },
    { tag: 'brand-200', className: 'text-brand-200' },
    { tag: 'brand-300', className: 'text-brand-300' },
    { tag: 'brand-400', className: 'text-brand-400' },
    { tag: 'brand-500', className: 'text-brand-500' }
  ];

  let html = children || '';

  // Nahrazení všech podporovaných značek
  supportedTags.forEach(({ tag, className }) => {
    const regex = new RegExp(`<${tag}>(.*?)<\/${tag}>`, 'g');
    html = html.replace(regex, `<span class="${className}">$1</span>`);
  });

  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};
export default RichText;
